import { SortOrder } from '@Utils/helpers/sortingHelpers';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@Services/redux/Store';
import { getSortedProjects } from './Helpers';
import { IProject, IProjectDocument } from './Interfaces';
import { IProjectState, initialProjectState } from './State';

const ProjectSlice = createSlice({
    name: 'Project',
    initialState: initialProjectState,
    reducers: {
        updateProjects(state, action) {
            state.projects = action.payload;
        },
        setProject(state, action) {
            state.selectedProject = action.payload;
            state.selectedProjectDocuments = null;
        },
        setProjectById(state, action) {
            state.selectedProject = state.projects.find(
                (p) => p.project_id === action.payload
            );
        },
        setSortOrder(state, action) {
            state.sortOrder = action.payload;
        },
        setSortByField(state, action) {
            state.sortByField = action.payload;
        },
        setSelectedProjectDocuments(
            state: IProjectState,
            action: PayloadAction<IProjectDocument[]>
        ) {
            state.selectedProjectDocuments = action.payload;
        },
    },
});

export const ProjectActions = ProjectSlice.actions;

export const projectsState = (state) =>
    getSortedProjects(
        state.project.projects,
        state.project.sortOrder,
        state.project.sortByField
    );

export const selectedProjectState = (state: RootState): IProject =>
    state.project.selectedProject;

export const selectedSortOrderState = (state: RootState): SortOrder =>
    state.project.sortOrder;

export const selectedSortByFieldState = (state: RootState) =>
    state.project.sortByField;

export const selectedProjectDocumentsState = (state: RootState) =>
    state.project.selectedProjectDocuments;

export default ProjectSlice.reducer;
